import { isNN} from '../utils/tools';
import { ref } from 'vue';


export const MEDIA_SCREEN_DEFAULT = 9999;
export const MEDIA_SCREEN_1370PX = 1370;
export const MEDIA_SCREEN_1200PX = 1200;
export const MEDIA_SCREEN_992PX = 992;
export const MEDIA_SCREEN_768PX = 768;
export const MEDIA_SCREEN_640PX = 640;
export const MEDIA_SCREEN_480PX = 480;
export const MEDIA_SCREEN_320PX = 320;


// 合同状态枚举
export const CONTRACT_STATUS = {
  FAIL: 0,
  AUDIT_PENDING: 1,
  EXEC_PENDING: 2,
  EXECUTING: 3,
  FINISH: 4,
};

export const CONTRACT_STATUS_OPTIONS = [
  { value: CONTRACT_STATUS.FAIL, label: '审核失败' },
  { value: CONTRACT_STATUS.AUDIT_PENDING, label: '待审核' },
  { value: CONTRACT_STATUS.EXEC_PENDING, label: '待履行' },
  { value: CONTRACT_STATUS.EXECUTING, label: '审核成功' },
  { value: CONTRACT_STATUS.FINISH, label: '已完成' },
];

// 合同类型枚举
export const CONTRACT_TYPES = {
  MAIN: 0,
  SUB: 1,
  SUPPLEMENT: 2,
};

export const CONTRACT_TYPE_OPTIONS = [
  { value: CONTRACT_TYPES.MAIN, label: '主合同' },
  { value: CONTRACT_TYPES.SUB, label: '子合同' },
  { value: CONTRACT_TYPES.SUPPLEMENT, label: '补充合同' },
];

// 合同收付类型枚举
export const CONTRACT_PAYMENT_TYPES = {
  PAYMENT: 0,
  RECEIPT: 1,
};

// 通知的优先级对应的TAG类型
export const NOTIFICATION_TYPES = {
  low: 'primary',
  middle: 'warning',
  high: 'danger',
};

//最小宽度--需要依据是否手机等判断
let cminw = ref(320);
let cminws = ref(`${cminw.value}px`);
export function setMinw(minw:number){
  cminw.value = minw;
  cminws.value = `${minw}px`;
}
export function minW(){
  return cminws.value;
}

//初始化最小宽度，如果是pad等手持设备，直接使用浏览器的值，否则使用480px
export function initMinw(){
  const isMobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if(isNN(isMobile)){//在手持设备上，浏览器一般是最大化的
    //获取在手持设备上的最小值（横屏，竖屏）
    let min = Math.min(document.documentElement.clientWidth, document.documentElement.clientHeight);   
    if(min <= 320){
      min -= 2;
    }else if(min <= 480){
      min -= 2;
    }else{
      min = 480;
    }
    setMinw(min);
  }else{//PC等直接使用480px
    setMinw(480);
  }
  console.log(`isMobile ${isMobile}, min-width: ${minW()}`)
};

//用于dialog的动态宽高度计算。
//使用静态值，一般而言只有一个dialog在上面
let w = ref({});
let minw = ref({});
let maxw = ref({});
let h = ref({});
let minh = ref({});
let maxh = ref({});

//比320大的就要归属到480尺寸上了
export function getScreen(width:number){
  if(width > 1370)return 9999;
  if(width > 1200)return 1370;
  if(width > 992)return 1200;
  if(width > 768)return 992;
  if(width > 640)return 768;
  if(width > 480)return 640;
  if(width > 320)return 480;
  return 320;
}

export function setWidth(screen:number, sw:string, sminw:string, smaxw:string){
    w[screen] = sw;     
    minw[screen] = sminw; 
    maxw[screen] = smaxw;
}

export function setHeight(screen:number, sh:string, sminh:string, smaxh:string){
    h[screen] = sh;
    minh[screen] = sminh;
    maxh[screen] = smaxh;
}

export function getWH(flag:string, screen:number){  
  if(flag === 'w')return w[screen];
  if(flag === 'minw')return minw[screen];
  if(flag === 'maxw')return maxw[screen];
  if(flag === 'h')return h[screen];
  if(flag === 'minh')return minh[screen];
  if(flag === 'maxh')return maxh[screen];
  return undefined;
};

